import {
	scrollTo
} from '../../utils/_scrollTo';

import{
	addAddress
}from  './_addAddress';

const setupAfterpay = () => {
	if($('#afterpay-button').length > 0 && $('#orderReviewForm').length > 0 && $('#creditCardForm input[name="piAmount"]').val().length > 0 && Number($('#creditCardForm input[name="piAmount"]').val()) > 0){
		$('#afterpay-button').on('click',function(){
			
			var data='';
			
			data += 'orderId=' + $('input[name="orderId"]:first').val();
			var billingAddressId = '';
			if($('#billingAddressCheck').prop('checked')){
				data += '&billingAddressId=' + $('#orderReviewForm input[name="shippingAddressId"]').val();
			} else {
				$('#shippingAddressForm input,#shippingAddressForm select').each(function(){
					if($(this).val() && $(this).val().length > 0){
						if($(this).prop('name') == 'zipCode'){
							$(this).val($(this).val().split('-').join(''));
						}
						data += '&'+$(this).prop('name')+'=' + $(this).val();
					}
				});
			}
			AfterPay.initialize({countryCode: "US"});
			AfterPay.open();
			AfterPay.onComplete = function(event) {
		        if (event.data.status == "SUCCESS") {
					$(".afterpay-express-button").css('pointer-events', 'auto');
					$(`<input name="orderToken" type="hidden" value="${event.data.orderToken}" />`).appendTo('#orderReviewForm');
		        	$(`<input name="isAfterpay" type="hidden" value="true" />`).appendTo('#orderReviewForm');
					$('input[name="CardType2"]').attr('checked', false);
					$('#afterpay').attr('checked', true);
					$('#creditCardForm').submit();	        
		        } else {
		        	// The customer cancelled the payment or closed the popup window.
					$(".afterpay-express-button").css('pointer-events', 'auto');
		        	if(console && console.log){
		        		console.log('afterpay returned ' + JSON.stringify(event.data));
		        	}
		        }
			}
			createCheckout(data);
		});
		$('#afterpay-button').on('keypress', function(e){
			if (e.which == 13) {
				var data='';
			
				data += 'orderId=' + $('input[name="orderId"]:first').val();
				var billingAddressId = '';
				if($('#billingAddressCheck').prop('checked')){
					data += '&billingAddressId=' + $('#orderReviewForm input[name="shippingAddressId"]').val();
				} else {
					$('#shippingAddressForm input,#shippingAddressForm select').each(function(){
						if($(this).val() && $(this).val().length > 0){
							if($(this).prop('name') == 'zipCode'){
								$(this).val($(this).val().split('-').join(''));
							}
							data += '&'+$(this).prop('name')+'=' + $(this).val();
						}
					});
				}
				AfterPay.initialize({countryCode: "US"});
				AfterPay.open();
				AfterPay.onComplete = function(event) {
					if (event.data.status == "SUCCESS") {
						$(".afterpay-express-button").css('pointer-events', 'auto');
						$(`<input name="orderToken" type="hidden" value="${event.data.orderToken}" />`).appendTo('#orderReviewForm');
						$(`<input name="isAfterpay" type="hidden" value="true" />`).appendTo('#orderReviewForm');
						$('input[name="CardType2"]').attr('checked', false);
						$('#afterpay').attr('checked', true);
						$('#creditCardForm').submit();	        
					} else {
						// The customer cancelled the payment or closed the popup window.
						$(".afterpay-express-button").css('pointer-events', 'auto');
						if(console && console.log){
							console.log('afterpay returned ' + JSON.stringify(event.data));
						}
					}
				}
				createCheckout(data);
			}
		});
	} else {
		$('#afterpay-button').hide();
	}
};

const setupAfterpayExpress = () => {
	if($('.afterpay-express-button').length > 0){
		 // ensure this function is defined before loading afterpay.js
		var afterpayJSDomain = $('.afterpay-express-button').data('js_domain');
		var afterpayMerchantKey = $('.afterpay-express-button').data('merchant_key');
	    var apayScript = document.createElement('script');
		apayScript.setAttribute('src', `https://${afterpayJSDomain}/afterpay.js?merchant_key=${afterpayMerchantKey}`);
		apayScript.setAttribute('onload', 'Dillards.initAfterpay()');
		apayScript.async = true;
		document.head.appendChild(apayScript);
	}
};

const initAfterpay = () => {
	var orderId = $('input[name="orderId"]:first').val();
	
      AfterPay.initializeForPopup({
        countryCode: 'US',
        onCommenceCheckout: function(actions) {
        	//this call does nothing but will push a persisted guest into an "active" guest state.
      	  $.ajax({
			url: "/webapp/wcs/stores/servlet/AfterPayExpressCheckout",
			cache: false,
			type: "POST",
	        data: {"persistCall": true},
	        async: false, 
	        xhrFields: { withCredentials: true },
	        crossDomain: true,
			success: function(json) {
				$(".afterpay-express-button").attr('style', 'pointer-events: none');
				//console.log('success');
			},
			error: function(json) {
				$(".afterpay-express-button").removeAttr('style');
				handleError('To continue checkout with Afterpay, please confirm your billing address is correct and try again.', 'Error response from Afterpay-' + JSON.stringify(json));
			}
		});
        	
        	var data = 'express=true&orderId=' + orderId;
        	createCheckout(data)
        },
        onShippingAddressChange: function (data, actions) {
        	data.orderId = orderId;
        	data.lastName = data.name;
        	data.city = data.suburb;
        	data.zipCode = data.postcode.split('-').join('');
        	shippingAddressAdd(data, actions);
        },
        onComplete: function (data) {
        	if(data.data.status=='SUCCESS'){
				
        		try { $(document).trigger('triggerCheckoutInitiate'); } catch (e) {}
        		var form = $('#ShopCartForm');
        		form.append('<input name="regErrorOnly" type="hidden" value="yes">');
        		form.append('<input name="isAfterpay" type="hidden" value="true">');
        		form.append('<input name="isRefNum" type="hidden" value="false">');
        		form.children('input[name="isPIAddNeeded"]').val('Y')
        		form.append(`<input name="orderToken" type="hidden" value="${data.data.orderToken}">`);
        		form.find('input[name="updateOrderTimer"]').remove();
        		form.find('input[name="skipCheck"]').remove();
        		form.children('input[name="URL"]').val('OrderReviewCmd');
        		form.prop('action', 'AfterPayExpressCheckout');
    			form.submit();
        	}
			if(data.data.status=='CANCELLED'){
				//console.log("cancelled");
				$(".afterpay-express-button").removeAttr('style');
			}
    
        },
        target: '.afterpay-express-button',
        buyNow: false,
        pickup: false,
      });
      if ($("input[id^=subFrequencyRadio_subscribe]:checked").length == 0) {
    	  $('.afterpay-express-button').show();
      }
};

const createCheckout = (data) => {
	$.ajax({
		url: "/webapp/wcs/stores/servlet/AfterPayCreateCheckout",
		cache: false,
		type: "POST",
        data: data,
		success: function(json) {
			if(json.JSONError){
				AfterPay.close();
				handleError(json.JSONError);
			} else{
				$('#errors').remove();				
				var responseJSON = json.JSON;
				if(responseJSON && responseJSON.afterpayResponse && responseJSON.afterpayResponse.token){
					var form = $('#creditCardForm');
					form.find('input[name="piAmount"]').remove()
					form.append(`<input name="piAmount" type="hidden" value="${responseJSON.afterpayRequest.amount.amount}">`);
					form.find('input[name="chargesForToday"]').remove()
					form.append(`<input name="chargesForToday" type="hidden" value="${responseJSON.afterpayRequest.amount.amount}">`);
					AfterPay.transfer({token: responseJSON.afterpayResponse.token});
					
				} else {
					AfterPay.close();
					var customerMessage = 'Your payment was not successful. Please return to Afterpay and try again, or select a different payment option.';
					var errorTrackingMessage = 'Did not get token back from Afterpay:-' + JSON.stringify(responseJSON);
					handleError(customerMessage, errorTrackingMessage);
				}
			}
		},
		error: function(json) {
			AfterPay.close();
			handleError('To continue checkout with Afterpay, please confirm your billing address is correct and try again.', 'Error response from Afterpay-' + JSON.stringify(json));
		}
	});
};

const shippingAddressAdd = (data, actions) => {
	const shippingData = data;
	
	var toPassAddress = Object.keys(data).map(function(key) {
        return encodeURIComponent(key) + '=' +
            encodeURIComponent(data[key]);
    }).join('&').split('null').join('');
	toPassAddress += "&nickName=AfterPayShipping";
	
	$.ajax({
		url: "/webapp/wcs/stores/servlet/shippingAddressAdd",
		cache: false,
		type: "POST",
        data: toPassAddress, 
        async: false,
		success: function(json, status, xhr) {
			if(json.JSONError){
				actions.reject(AfterPay.constants.SERVICE_UNAVAILABLE);
			} else{
				var responseJSON = json.JSON;
				if(responseJSON && responseJSON.order && responseJSON.order.defaultShippingMethod){
					var shipMethod = responseJSON.order.defaultShippingMethod;
					if(json.JSON.order && json.JSON.order.orderItems[0] && json.JSON.order.orderItems[0].shippingAddressId){
						var form = $('#ShopCartForm');
						form.children('input[name="name"]').remove();
						form.append(`<input name="name" type="hidden" value="${shippingData.name}">`);
						form.children('input[name="address1"]').remove();
						form.append(`<input name="address1" type="hidden" value="${shippingData.address1}">`);
						form.children('input[name="address2"]').remove();
						if(shippingData.address2 != null){
							form.append(`<input name="address2" type="hidden" value="${shippingData.address2}">`);
						}
						form.children('input[name="city"]').remove();
						form.append(`<input name="city" type="hidden" value="${shippingData.city}">`);
						form.children('input[name="state"]').remove();
						form.append(`<input name="state" type="hidden" value="${shippingData.state}">`);
						form.children('input[name="zipCode"]').remove();
						form.append(`<input name="zipCode" type="hidden" value="${shippingData.zipCode}">`);
						form.children('input[name="billing_address_id"]').remove();
						form.append(`<input name="billing_address_id" type="hidden" value="${json.JSON.order.orderItems[0].shippingAddressId}">`);
//						form.children('input[name="editAddressId"]').val(json.JSON.order.orderItems[0].shippingAddressId);
					}
					shippingMethodChange(actions, shipMethod, responseJSON.order.orderId);
				} else {
					actions.reject(AfterPay.constants.SHIPPING_ADDRESS_UNSUPPORTED);
				}
			}
		},
		error: function(json) {
			AfterPay.close();
			handleError('To continue checkout with Afterpay, please confirm your billing address is correct and try again.', 'Error response from Afterpay-' + JSON.stringify(json));
		}
	});
};

const shippingMethodChange = (actions, shipMethod, orderId) => {
	$.ajax({
		url: "/webapp/wcs/stores/servlet/ShipModeUpdate",
		cache: false,
		type: "POST",
        data: {"globalShippingMode": shipMethod.id, "massUpdateShipMode":"Y", "orderId": orderId},
        async: false, 
		success: function(json) {
			if(json.JSONError){
				AfterPay.close();
				handleError('An error occured updating your shipping method. Please try Afterpay again or continue to checkout.', 'Error response from ShipModeUpdate-' + JSON.stringify(json));
			} else{
				var form = $('#ShopCartForm');
				form.find('input[name="piAmount"]').remove()
				form.append(`<input name="piAmount" type="hidden" value="${json.JSON.newOrderTotal.split('$').join('')}">`);
				shipMethod.description = shipMethod.deliveryTime;
				shipMethod.shippingAmount = { "amount": `${json.JSON.newShipping.split('$').join('').split('FREE').join('0.00')}`, currency: 'USD'};
				shipMethod.orderAmount = { "amount": `${json.JSON.newOrderTotal.split('$').join('')}`, currency: 'USD'};
				shipMethod.taxAmount = { "amount": `${json.JSON.newTax.split('$').join('')}`, currency: 'USD'};
				delete shipMethod['price'];
				delete shipMethod['deliveryTime'];

				actions.resolve([shipMethod]);
			}
		},
		error: function(json) {
			AfterPay.close();
			handleError('To continue checkout with Afterpay, please confirm your billing address is correct and try again.', 'Error response from Afterpay-' + JSON.stringify(json));
		}
	});
};

const handleError = (errorMessage, trackingMessage) => {
	if(errorMessage){
		$('#errors').remove();
		var errorContent = `<div id="errors" class="alert alert-danger alert-dismissible" role="alert">
							<button id="error-message" class="alert-dismiss close" type="button" data-dismiss="alert" aria-label="close" aria-label="close">&times;</button>
							${errorMessage}</div>`;
		$('#step2Content').prepend(errorContent);
		if(Dillards.validateThisForm && $('#shippingAddressForm button').length > 0){
			Dillards.validateThisForm($('#shippingAddressForm'));
			$('#shippingAddressForm button').eq(0).click();		
		}
		scrollTo('#step2Content');
	}
	if(trackingMessage){
		$('#afterpay-error-tracking').remove();
		var newHTML = `<div class="hidden" id="afterpay-error-tracking">${trackingMessage}</div>`;
		$('#content-wrapper').append(newHTML);
	}
};

export {
	setupAfterpay,
	setupAfterpayExpress,
	initAfterpay
}
